import { Formik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';
import { Button, Buttons, CancelButton, Checkbox, Field, Form, FormMessage, ModalCard } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useIsMounted } from '~/hooks';
import { Description } from './HarvestSetup';

export function CaptureCredentials({ onClose, onFinish }) {
  const api = useApi();
  const isMounted = useIsMounted();
  const { workspace } = useWorkspace();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [showToken, setShowToken] = useState(false);

  const initialValues = { accountId: '', token: '' };

  async function handleSubmit(values) {
    setIsLoading(true);
    setErrorMessage();

    try {
      await api.www.workspaces(workspace.id).harvest.setup({
        accountId: values.accountId.trim(),
        token: values.token.trim(),
      });
      onFinish();
    } catch ({ message }) {
      if (message) {
        setErrorMessage(message);
      } else {
        setErrorMessage('There was a problem completing your request. Please try again later.');
      }
    } finally {
      if (isMounted.current) {
        setIsLoading(false);
      }
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={Yup.object().shape({
        accountId: Yup.string().label('Account ID').max(255).required(),
        token: Yup.string().label('Personal Access Token').max(1024).required(),
      })}>
      {() => (
        <Form>
          <ModalCard.Body>
            <Description>
              To connect to Harvest, you need a Personal Access Token. Create one at{' '}
              <a href="https://id.getharvest.com/oauth2/access_tokens/new" target="_blank" rel="noopener noreferrer">
                id.getharvest.com
              </a>{' '}
              and copy the Account ID and the token shown there.
            </Description>
            <Form.Control>
              <Field.Text name="accountId" placeholder="Account ID" maxLength={255} />
            </Form.Control>
            <Form.Control>
              <Field.Text
                name="token"
                type={showToken ? 'text' : 'password'}
                placeholder="Personal Access Token"
                maxLength={1024}
              />
            </Form.Control>
            <Checkbox
              checked={showToken}
              onChange={() => setShowToken(!showToken)}
              label="Show Personal Access Token"
            />
            {errorMessage && <FormMessage.Error>{errorMessage}</FormMessage.Error>}
          </ModalCard.Body>
          <ModalCard.Footer>
            <Buttons align="right">
              <CancelButton onClick={onClose} style={{ marginRight: 'auto' }}>
                Close
              </CancelButton>
              <Button type="submit" isLoading={isLoading}>
                Save
              </Button>
            </Buttons>
          </ModalCard.Footer>
        </Form>
      )}
    </Formik>
  );
}
